<!-- in case user_wise_id is null, use base 26 to display offer id -->
<span class="float-right offer-pair-id">{{getID()}}</span>
<i class="fa fa-bookmark memo-bookmark" *ngIf="offer?.memo?.body" ngbTooltip="メモがあります。"></i>

<ng-container *ngIf=" offer.progress_status">
  <app-matching-label *ngIf="offer" [side]="mailType" [mailInfo]="mailInfo" [actionLog]=actionLog
    [matchingOffer]="offer" [orderFinished]="mailInfo.order_finished" [timeOut]="mailInfo.is_time_out_to_approve">
  </app-matching-label>
  <app-skill-list-tag [haveSkillList]="haveSkillList"></app-skill-list-tag>
  <app-offer-action-user [actionLog]="actionLog" [matchingOffer]="offer" [mailType]="mailType" [mailInfo]="mailInfo">
  </app-offer-action-user>
</ng-container>
